import { FileSearch, Cpu, ClipboardList, Wrench, Hammer, Cog } from "lucide-react";

const services = [
  { icon: FileSearch, title: "Feasibility Studies", desc: "Techno‑economic evaluation of energy transition opportunities." },
  { icon: Cpu, title: "Technology Evaluation", desc: "Independent assessment and selection of best‑fit technologies." },
  { icon: ClipboardList, title: "FEED & PMC", desc: "Front‑end engineering and project management consultancy." },
  { icon: Hammer, title: "EPC / EPCM", desc: "End‑to‑end engineering, procurement and construction delivery." },
  { icon: Wrench, title: "O&M Support", desc: "Operations and maintenance support for sustained performance." },
  { icon: Cog, title: "BOOT & Manufacturing", desc: "Build‑Own‑Operate‑Transfer plus manufacturing partnerships." },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="py-20 lg:py-28 bg-secondary/40">
      <div className="container-wide">
        <div className="max-w-2xl">
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-primary">
            What We Offer
          </p>
          <h2 className="mt-3 font-display font-bold text-3xl sm:text-4xl lg:text-5xl text-foreground">
            Comprehensive services across the project lifecycle
          </h2>
          <p className="mt-5 text-base lg:text-lg text-muted-foreground leading-relaxed">
            One‑stop solutions for energy transition and emissions mitigation —
            tailored, dependable and aligned to global net carbon zero targets.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((s) => (
            <div
              key={s.title}
              data-testid={`service-${s.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="group rounded-2xl border border-border bg-white p-6 hover-lift"
            >
              <div className="flex items-start gap-4">
                <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors">
                  <s.icon className="h-5 w-5" />
                </span>
                <div>
                  <h3 className="font-display font-semibold text-lg text-foreground">
                    {s.title}
                  </h3>
                  <p className="mt-1.5 text-sm text-muted-foreground leading-relaxed">
                    {s.desc}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
